import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from 'core/route.protected';
import Loading from 'components/_common/Loading';
import AdminList from './Admin.list';
import AdminUpdate from './Admin.update';

function Admin() {
    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <AdminList />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>

                <Route
                    path="/add"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <AdminUpdate />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>

                <Route
                    path="/update/:username"
                    element={
                        <ProtectedRoute>
                            <React.Suspense fallback={<Loading />}>
                                <AdminUpdate />
                            </React.Suspense>
                        </ProtectedRoute>
                    }
                ></Route>
            </Routes>
        </>
    );
}

export default Admin;
